import { render, staticRenderFns } from "./RowItemValue.vue?vue&type=template&id=aaf86f24"
import script from "./RowItemValue.vue?vue&type=script&lang=js"
export * from "./RowItemValue.vue?vue&type=script&lang=js"
import style0 from "./RowItemValue.vue?vue&type=style&index=0&id=aaf86f24&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports